package ru.villawonka.app.presentation.sharedviews.postList.compose.view

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.components.AppBadge
import ru.villawonka.app.presentation.design.components.AppBadgeType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.model.AccommodationAdditionUIModel
import ru.villawonka.app.presentation.model.PostUIModel
import ru.villawonka.app.resources.AppResources

@Composable
fun FloatingBadgesView(post: PostUIModel) {
    Row(modifier = Modifier.padding(8.dp)) {
        when (post) {
            is PostUIModel.Accommodation -> {
                if (post.isNew) {
                    AppBadge(
                        text = AppResources.strings.badgeNew,
                        type = AppBadgeType.INFO
                    )
                }
                post.additions.find {
                    it is AccommodationAdditionUIModel.HasDiscount
                }?.let {
                    AppSpacer(8.dp)
                    AppBadge(
                        text = it.key,
                        type = AppBadgeType.SALE
                    )
                }
            }
        }
    }
}